import {createApp} from 'vue'
import DeleteEventModal from './DeleteEventModal'

const el = '.kb-component--delete-event-modal'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DeleteEventModalDOM)=>{
            const component = createApp(DeleteEventModal).use(Store)
            component.mount(DeleteEventModalDOM)
        })
    }
}